import { faHeartPulse } from "@fortawesome/free-solid-svg-icons";
import { faDumbbell } from "@fortawesome/free-solid-svg-icons";
import { faWeightHanging } from "@fortawesome/free-solid-svg-icons";
import { faPersonSwimming } from "@fortawesome/free-solid-svg-icons";

let FeaturesItems =[
    {
        id:1,
        itemIcon:faHeartPulse,
        itemTitle:'Cardio',
        itemDescription:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab suscipit, labore obcaecati molestias eius eveniet necessitatibus eum aspernatur molestiae inventore.'
    },
    {
        id:2,
        itemIcon:faDumbbell ,
        itemTitle:'Dumbbell exercise',
        itemDescription:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab suscipit, labore obcaecati molestias eius eveniet necessitatibus eum aspernatur molestiae inventore.'
    },
    {
        id:3,
        itemIcon:faWeightHanging,
        itemTitle:'Weight Lifting',
        itemDescription:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab suscipit, labore obcaecati molestias eius eveniet necessitatibus eum aspernatur molestiae inventore.'
    },
    {
        id:4,
        itemIcon:faPersonSwimming,
        itemTitle:'Swimming',
        itemDescription:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab suscipit, labore obcaecati molestias eius eveniet necessitatibus eum aspernatur molestiae inventore.'
    }
]
export default FeaturesItems;